var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComponent481(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.062,
    height: 39.061,
    viewBox: "0 0 39.062 39.061",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_48_1",
    "data-name": "Component 48 \\u2013 1",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_711",
    "data-name": "Group 711",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M54.583,166.566h0a19.031,19.031,0,0,1-19.031-19.03h0a19.031,19.031,0,0,1,19.031-19.031h0a19.031,19.031,0,0,1,19.031,19.031h0A19.031,19.031,0,0,1,54.583,166.566Z",
    transform: "translate(-35.552 -128.505)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M44.444,153.907a11.833,11.833,0,0,0,18.2-10.507,8.433,8.433,0,0,0,2.075-2.154,8.3,8.3,0,0,1-2.389.655,4.166,4.166,0,0,0,1.829-2.3,8.347,8.347,0,0,1-2.641,1.01,4.164,4.164,0,0,0-7.09,3.8,11.807,11.807,0,0,1-8.575-4.347,4.165,4.165,0,0,0,1.287,5.555,4.147,4.147,0,0,1-1.885-.521,4.166,4.166,0,0,0,3.337,4.133,4.165,4.165,0,0,1-1.878.07,4.162,4.162,0,0,0,3.886,2.89A8.366,8.366,0,0,1,44.444,153.907Z",
    transform: "translate(-35.552 -128.505)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent481);
export default __webpack_public_path__ + "static/media/Component48–1.7611debbd0f9f9b4c2e2374154090cc1.svg";
export { ForwardRef as ReactComponent };